import { render, staticRenderFns } from "./sync-rule.vue?vue&type=template&id=21000d8a&"
import script from "./sync-rule.vue?vue&type=script&lang=js&"
export * from "./sync-rule.vue?vue&type=script&lang=js&"
import style0 from "./sync-rule.vue?vue&type=style&index=0&id=21000d8a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports